/*
    Explanation:
    MON - Aug, MONTH - August
    FULL_DAY_NAME - Sunday, DAY_NAME - Sun
    DAY_ORDER: 1st
    YEAR: 2019
*/
export const timeFormats = {
    FULL_DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
    DAY_ORDER_MON_YEAR: 'Do MMM YYYY',
    DAY_ORDER: 'Do',
    FULL_DAY_NAME_MON_DAY_ORDER_YEAR: 'dddd MMM Do YYYY',
    FULL_DAY_NAME_MON_DAY_ORDER: 'dddd MMM Do',
    INCOMPLETE_TIME: 'HH:mm',
    COMPLETE_TIME: 'HH:mm:ss',
    FULL_DAY_NAME: 'dddd',
    SERVER_DATE_TYPE: 'YYYY-MM-DD',
    SERVER_DATE_TIME_TYPE: 'YYYY-MM-DD HH:mm:ss',
    INPUT_DATE_TYPE: 'YYYY-MM-DD',
    DAY_ORDER_MON: 'Do MMM',
    YEAR: 'YYYY',
    MONTH_DAY: 'MMMM-DD',
    DAY_NAME_DAY_ORDER_MON: 'ddd Do MMM',
    SECONDS: 'ss',
    MON: 'MMM',
};

export const timeValues = {
    MINUTE: 60,
    HOUR: 3600,
    DAY: 86400,
    MONTH: 2592000,
    YEAR: 946080000,
};

export const millisecondTimeValues = {
    SECOND: 1000,
    MINUTE: 60000,
};

export const timeMetrics = ['days', 'hours', 'minutes', 'seconds'];



// WEBPACK FOOTER //
// ./src/Constants/timeFormats.js